// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Subject from "./subject.js"

const modelClassData = {
  "attributes": {
    "account_no": {
      "column": {
        "default": null,
        "name": "account_no",
        "null": false,
        "type": "string"
      },
      "name": "account_no",
      "selected_by_default": null,
      "translated": null
    },
    "account_type_subject_id": {
      "column": {
        "default": null,
        "name": "account_type_subject_id",
        "null": false,
        "type": "uuid"
      },
      "name": "account_type_subject_id",
      "selected_by_default": null,
      "translated": null
    },
    "branch_no": {
      "column": {
        "default": null,
        "name": "branch_no",
        "null": false,
        "type": "string"
      },
      "name": "branch_no",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "primary": {
      "column": {
        "default": false,
        "name": "primary",
        "null": false,
        "type": "boolean"
      },
      "name": "primary",
      "selected_by_default": null,
      "translated": null
    },
    "smart_bank_account_no": {
      "column": {
        "default": null,
        "name": "smart_bank_account_no",
        "null": true,
        "type": "string"
      },
      "name": "smart_bank_account_no",
      "selected_by_default": null,
      "translated": null
    },
    "vendor_no": {
      "column": {
        "default": null,
        "name": "vendor_no",
        "null": true,
        "type": "string"
      },
      "name": "vendor_no",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "BankAccount",
  "collectionKey": "bank_accounts",
  "collectionName": "bank_accounts",
  "i18nKey": "bank_account",
  "camelizedLower": "bankAccount",
  "name": "BankAccount",
  "nameDasherized": "bank-account",
  "pluralName": "bank_accounts",
  "ransackable_associations": [
    {
      "className": "Subject",
      "collectionName": "subjects",
      "foreignKey": "account_type_subject_id",
      "name": "account_type_subject",
      "macro": "belongs_to",
      "resource_name": "Subject",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "account_no",
      "column": {
        "default": null,
        "name": "account_no",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "account_type_subject_id",
      "column": {
        "default": null,
        "name": "account_type_subject_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "branch_no",
      "column": {
        "default": null,
        "name": "branch_no",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_account_type_subject_id",
      "column": {
        "default": null,
        "name": "old_account_type_subject_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "primary",
      "column": {
        "default": false,
        "name": "primary",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "smart_bank_account_no",
      "column": {
        "default": null,
        "name": "smart_bank_account_no",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vendor_no",
      "column": {
        "default": null,
        "name": "vendor_no",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Subject",
      "collectionName": "subjects",
      "foreignKey": "account_type_subject_id",
      "name": "account_type_subject",
      "macro": "belongs_to",
      "resource_name": "Subject",
      "through": null
    }
  ],
  "paramKey": "bank_account",
  "primaryKey": "id"
}

/** Frontend model for BankAccount. */
export default class BankAccount extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  accountNo() {
    return this.readAttributeUnderscore("account_no")
  }

  /** @returns {boolean} */
  hasAccountNo() {
    const value = this.accountNo()

    return this._isPresent(value)
  }

  /** @returns {string} */
  accountTypeSubjectId() {
    return this.readAttributeUnderscore("account_type_subject_id")
  }

  /** @returns {boolean} */
  hasAccountTypeSubjectId() {
    const value = this.accountTypeSubjectId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  branchNo() {
    return this.readAttributeUnderscore("branch_no")
  }

  /** @returns {boolean} */
  hasBranchNo() {
    const value = this.branchNo()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  primary() {
    return this.readAttributeUnderscore("primary")
  }

  /** @returns {boolean} */
  hasPrimary() {
    const value = this.primary()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  smartBankAccountNo() {
    return this.readAttributeUnderscore("smart_bank_account_no")
  }

  /** @returns {boolean} */
  hasSmartBankAccountNo() {
    const value = this.smartBankAccountNo()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  vendorNo() {
    return this.readAttributeUnderscore("vendor_no")
  }

  /** @returns {boolean} */
  hasVendorNo() {
    const value = this.vendorNo()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  setPrimary(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "set_primary",
        primaryKey: this.primaryKey(),
        collectionName: "bank_accounts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  upsertInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "upsert_in_business_central",
        primaryKey: this.primaryKey(),
        collectionName: "bank_accounts",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./subject.js").default | null} */
  accountTypeSubject() {
    return this._readBelongsToReflection({modelClass: Subject, reflectionName: "account_type_subject"})
  }

  /** @returns {Promise<import("./subject.js").default | null>} */
  loadAccountTypeSubject() {
    if (!("accountTypeSubjectId" in this)) throw new Error("Foreign key method wasn't defined: accountTypeSubjectId")

    const id = this.accountTypeSubjectId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "account_type_subject",
        model: this,
        modelClass: Subject
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./subject.js").default | null>} */
  ensureAccountTypeSubjectLoaded() {
    return this.ensureAssociationLoaded("account_type_subject")
  }
}
